import axios from "@/axios";
import {Module} from "vuex";

const state = () => ({
    pages: [],
    events: [],
    news: [],
    festivals: []
});

const getters = {
    getPages(state: any){
        return state.pages;
    },
    getEvents(state: any){
        return state.events;
    },
    getNews(state: any){
        return state.news;
    },
    getFestivals(state: any){
        return state.festivals;
    }
};
const actions = {
    async fetchPagesWithCountry({commit}: any, countryId: any){
        const response = await axios.get('/blog/countryIntro/'+countryId);
        commit('savePages', response.data);
    },
    async fetchPagesWithState({commit}: any, stateId: any){
        const response = await axios.get('/blog/stateIntro/'+stateId);
        commit('savePages', response.data);
    },
    async fetchPagesWithRegion({commit}: any, regionId: any){
        const response = await axios.get('/blog/regionIntro/'+regionId);
        commit('savePages', response.data);
    },
    async fetchPagesWithShire({commit}: any, shireId: any){
        const response = await axios.get('/blog/shireIntro/'+shireId);
        commit('savePages', response.data);
    },
    async fetchPagesWithTown({commit}: any, postCode: any){
        const response = await axios.get('/blog/townIntro/'+postCode);
        commit('savePages', response.data);
    },
    async fetchNews({commit}: any, townId: any){
        const response = await axios.get('/blog/news/'+townId);
        commit('saveNews', response.data);
    },
    async fetchEvents({commit}: any, townId: any){
        const response = await axios.get('/blog/events/'+townId);
        commit('saveEvents', response.data);
    },
    async fetchFestivals({commit}: any, townId: any){
        const response = await axios.get('/blog/festivals/'+townId);
        commit('saveFestivals', response.data);
    }
    // async fetchPagesWithId({commit}: any, stateId: any){
    //     const response = await axios.get("/blog/shiresWithState/"+stateId);
    //     commit('saveShires', response.data);
    // }
};
const mutations = {
    savePages(state: any, payload: any){
        state.pages = payload;
        localStorage.setItem('pages',JSON.stringify(state.pages))
    },
    saveEvents(state: any, payload: any){
        state.events = payload;
        localStorage.setItem('events',JSON.stringify(state.events))
    },
    saveNews(state: any, payload: any){
        state.news = payload;
        localStorage.setItem('news',JSON.stringify(state.news))
    },
    saveFestivals(state: any, payload: any){
        state.festivals = payload;
        localStorage.setItem('festivals',JSON.stringify(state.festivals))
    }
};

export const pages: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
